












import { EntityLocation, FeedTank, Transceiver } from '@/api';
import { BvTableFieldArray } from 'bootstrap-vue';
import { Component, InjectReactive, Vue } from 'vue-property-decorator';
import { FeedProduct, feedTankOverviewFields } from '../../../models';
import { sortEntitiesByStatus } from '@/common/FormattingUtils';

@Component({})
export default class FeedTanksOverview extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	public get overviewFields(): BvTableFieldArray {
		return feedTankOverviewFields;
	}

	public get feedTanks(): FeedTank &
		{
			transceiver: Transceiver | null;
			entitylocation: EntityLocation | null;
		}[] {
		return sortEntitiesByStatus<
			FeedTank & {
				transceiver: Transceiver | null;
				entitylocation: EntityLocation | null;
			}
		>(this.feedProduct.feedtanks);
	}

	public onFeedTankClicked(feedTank: FeedTank): void {
		if (!feedTank.id) {
			return;
		}
		this.$router.push({
			name: 'products.feed.feedtanks.tankdetail.general',
			params: { feedTankId: feedTank.id.toString() },
		});
	}
}
